import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { getId, usePermissions } from "../../user/User"
import TagDetailView from "./TagDetailView"

const TagCreate = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.tag !== undefined && !permissions.tag) {
            toast.error("You don't have permission to create tags!")
            navigate("/")
        }
    }, [permissions])
    
    const [name, setName] = useState("")

    return <TagDetailView id={null}
        name={name} setName={setName}
    />
}
   
export default TagCreate
